import { BrowserRouter } from 'react-router-dom';
import PortfolioSite from './Pages/PortfolioSite';

function App() {
  return (
    <BrowserRouter>
      <PortfolioSite />
    </BrowserRouter>
  );
}

export default App;
